// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.seat {
  background-color: #444451;
  height: 2.7rem;
  width: calc(50% - 20px);
  margin: 5px 10px;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.seat.mobile {
  background-color: #444451;
  height: 2.7rem;
  width: calc(50% - 10px);
  margin: 5px;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.seat.selected {
  background-color: #6feaf6;
}

.seat.used {
  background-color: #777;
}





/* 좌석 hover */
/* .seat:not(.occupied):hover {
  cursor: pointer;
  transform: scale(1.2);
} */



/* 좌석에 사용자 이름 */
.userName {
  color: #fff;
  font-size: larger;
  text-align: center;
}
.userName-mobile {
  color: #fff;
  font-size: 1rem;
  text-align: center;
}




/* 다이얼 안에 컨텐츠 */
.workPlace-dialog {
  max-width: 25rem;
  /* max-width: min-content;
  min-width: 20em; */
  padding: 0 !important;
}
.workPlace-content{
  padding: 1rem 1rem;
}
.workPlace-title{
  padding: 0.5rem 1rem;
}
.workPlace-grid{
  border-top: 3px solid #f1f1f1dc;
}

/* 다이얼 */
  /* @media (max-width: 768px) {
    .workPlace-dialog {
      width: 100%;
      max-width: max-content; 
      min-height: none;
    }
  } */




/* 라디오 버튼 */
#demo-radio-buttons-group-label {
  font-size: 1.5rem;
  font-weight: bold;
}








/* datepicker */
  .workPlace datepicker {
    display: flex;
    align-items: center;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    height: 46px;
    text-align: center;

  } 


  /* *************************   수정   ***************************** */
  /* 수정 시 datepicker */
  .workPlace-content .react-datepicker {
    width: -webkit-fill-available;
    padding: 1rem;
  }

    /* 버튼 */
    .workPlace-content .react-datepicker__navigation {
      height: 40px;
      top: 1rem;
    }
    .workPlace-content .react-datepicker__navigation--previous {
      left: 1rem;
    }
    .workPlace-content .react-datepicker__navigation--next {
      right: 1rem;
    }


    /* 날짜 나오는 헤더 */
    .workPlace-content .react-datepicker__header{
      padding: 0.5rem 0rem 0.5rem 0rem;
      border-bottom: none;
    }
      /* 안에 날짜 */
      .workPlace-content .react-datepicker__current-month {
        font-size: large;
      }


    /* 달 전체 안쪽 */
    .workPlace-content .react-datepicker__month-container {
      float: none;
    }


    /* 요일 전체 */
    .workPlace-content .react-datepicker__day-names {
      font-size: medium;
      margin-top: 0.5rem;
    }
      /* 요일 요소 하나 하나 */
      .workPlace-content .react-datepicker__day-name {
        margin: 0.35rem 0.5rem;
      }


    /* 일 */
    .workPlace-content .react-datepicker__day {
      margin: 0.35rem 0.5rem;
      font-size: medium;
    }



  /* *************************   등록   ***************************** */
  /* 등록 시 나오는 datepicker 사이즈 */
  .workPlace-insertContent .react-datepicker {
    width: auto;
    padding: 1rem;
  }


  /* 날짜 선택 시 나타나는 */
  .custom-input-workPlace {
    background-color: rgb(0, 0, 0);
    color: white;
    border: 1px solid rgb(0, 0, 0);
    padding: 0.5rem 1rem;
    /* border-radius: 5px; */
    cursor: pointer;
    font-size: large;
    font-weight: 400;
    width : max-content;
    margin: 0.5em 0em;
    /* box-shadow: 0px 1px cornflowerblue; */
  }

  .custom-input-workPlace:active {
    box-shadow: 0 0 0; 
    color: #fff;
  }

  .workPlace-content .react-datepicker__header {
    background-color: #fff;
  }


  /* .workPlace-content .react-datepicker__day--today{
    border-radius: 1rem;
    background-color: #008fff !important;
    color: #fff !important;
  }  */

  /* 하루 */
  .workPlace-content .react-datepicker__day--selected {
    border-radius: 1rem;
    background-color: #008fff !important;
    color: #fff !important;
  } 


  /* range 로 날짜  */
  .workPlace-content .react-datepicker__day--range-start{
    border-radius: 1rem 0rem 0rem 1rem;
    background-color: #008fff !important;
    color: #fff !important;
  } 
  .workPlace-content .react-datepicker__day--range-end{
    border-radius: 0rem 1rem 1rem 0rem;
    background-color: #008fff !important;
    color: #fff !important;
  } 
  .workPlace-content .react-datepicker__day--range-start.react-datepicker__day--range-end{
    border-radius: 1rem !important;
    background-color: #008fff !important;
    color: #fff !important;
  } 


  .workPlace-content .react-datepicker__day--in-range{
    background-color: #b5dfff;
    color: #000;
  }

  /* 선택할 때 시작 날짜 */
  .workPlace-content .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start {
    border-radius: 1rem 0rem 0rem 1rem;
    background-color: #008fff;
    color: #fff;
  }
  .workPlace-content .react-datepicker__day--in-selecting-range {
    background-color: #b5dfff;
    color: #000;
  }




/*  */
  .MuiFormControlLabel-label {
    font-size: large !important;
  }


/* 선택한 지역 안에 흰 글씨 */
  .myWorkPlace-text{
    color: #fff;
    font-size: small;
  }




  /* 통계 호버 시 툴팁 */
 .tooltip {
    display: flex;
    flex-direction: column;
    width: max-content;
    margin: 1rem;
 }
 .tooltip-name {
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
    border-bottom:1px solid rgb(175, 175, 175);
 }
 .tooltip-name-text {
    font-size: 1.25rem;
    font-weight: 700;
 }

 .tooltip-text {
    font-size: 1.25rem;
    font-weight: 700;
 }
 .tooltip-place {
    font-size: 1.25rem;
 }
 .tooltip-date {
    font-size: 1.25rem;
 }



/* 탭 */
.workplace-tabs .Mui-selected h4{
  /* border: 1px solid; */
  font-weight: bold !important;
}

.workplace-tabs {
  background-color: #005fff3d !important;
}

`, "",{"version":3,"sources":["webpack://./src/layouts/workPlace/workPlace.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;;;;;AAMA,aAAa;AACb;;;GAGG;;;;AAIH,eAAe;AACf;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;;;;AAKA,eAAe;AACf;EACE,gBAAgB;EAChB;oBACkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,+BAA+B;AACjC;;AAEA,QAAQ;EACN;;;;;;KAMG;;;;;AAKL,WAAW;AACX;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;;;;;;;;AASA,eAAe;EACb;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;;EAEpB;;;EAGA,mEAAmE;EACnE,oBAAoB;EACpB;IACE,6BAA6B;IAC7B,aAAa;EACf;;IAEE,OAAO;IACP;MACE,YAAY;MACZ,SAAS;IACX;IACA;MACE,UAAU;IACZ;IACA;MACE,WAAW;IACb;;;IAGA,cAAc;IACd;MACE,gCAAgC;MAChC,mBAAmB;IACrB;MACE,UAAU;MACV;QACE,gBAAgB;MAClB;;;IAGF,YAAY;IACZ;MACE,WAAW;IACb;;;IAGA,UAAU;IACV;MACE,iBAAiB;MACjB,kBAAkB;IACpB;MACE,gBAAgB;MAChB;QACE,sBAAsB;MACxB;;;IAGF,MAAM;IACN;MACE,sBAAsB;MACtB,iBAAiB;IACnB;;;;EAIF,mEAAmE;EACnE,4BAA4B;EAC5B;IACE,WAAW;IACX,aAAa;EACf;;;EAGA,iBAAiB;EACjB;IACE,8BAA8B;IAC9B,YAAY;IACZ,8BAA8B;IAC9B,oBAAoB;IACpB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;;EAGA;;;;MAII;;EAEJ,OAAO;EACP;IACE,mBAAmB;IACnB,oCAAoC;IACpC,sBAAsB;EACxB;;;EAGA,gBAAgB;EAChB;IACE,kCAAkC;IAClC,oCAAoC;IACpC,sBAAsB;EACxB;EACA;IACE,kCAAkC;IAClC,oCAAoC;IACpC,sBAAsB;EACxB;EACA;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,sBAAsB;EACxB;;;EAGA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA,gBAAgB;EAChB;IACE,kCAAkC;IAClC,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;;;;;AAKF,KAAK;EACH;IACE,2BAA2B;EAC7B;;;AAGF,mBAAmB;EACjB;IACE,WAAW;IACX,gBAAgB;EAClB;;;;;EAKA,eAAe;CAChB;IACG,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;CACf;CACA;IACG,qBAAqB;IACrB,oBAAoB;IACpB,0CAA0C;CAC7C;CACA;IACG,kBAAkB;IAClB,gBAAgB;CACnB;;CAEA;IACG,kBAAkB;IAClB,gBAAgB;CACnB;CACA;IACG,kBAAkB;CACrB;CACA;IACG,kBAAkB;CACrB;;;;AAID,MAAM;AACN;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["\n.seat {\n  background-color: #444451;\n  height: 2.7rem;\n  width: calc(50% - 20px);\n  margin: 5px 10px;\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n}\n.seat.mobile {\n  background-color: #444451;\n  height: 2.7rem;\n  width: calc(50% - 10px);\n  margin: 5px;\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.seat.selected {\n  background-color: #6feaf6;\n}\n\n.seat.used {\n  background-color: #777;\n}\n\n\n\n\n\n/* 좌석 hover */\n/* .seat:not(.occupied):hover {\n  cursor: pointer;\n  transform: scale(1.2);\n} */\n\n\n\n/* 좌석에 사용자 이름 */\n.userName {\n  color: #fff;\n  font-size: larger;\n  text-align: center;\n}\n.userName-mobile {\n  color: #fff;\n  font-size: 1rem;\n  text-align: center;\n}\n\n\n\n\n/* 다이얼 안에 컨텐츠 */\n.workPlace-dialog {\n  max-width: 25rem;\n  /* max-width: min-content;\n  min-width: 20em; */\n  padding: 0 !important;\n}\n.workPlace-content{\n  padding: 1rem 1rem;\n}\n.workPlace-title{\n  padding: 0.5rem 1rem;\n}\n.workPlace-grid{\n  border-top: 3px solid #f1f1f1dc;\n}\n\n/* 다이얼 */\n  /* @media (max-width: 768px) {\n    .workPlace-dialog {\n      width: 100%;\n      max-width: max-content; \n      min-height: none;\n    }\n  } */\n\n\n\n\n/* 라디오 버튼 */\n#demo-radio-buttons-group-label {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n\n\n\n\n\n\n\n/* datepicker */\n  .workPlace datepicker {\n    display: flex;\n    align-items: center;\n    border-radius: 4px;\n    box-sizing: border-box;\n    width: 100%;\n    height: 46px;\n    text-align: center;\n\n  } \n\n\n  /* *************************   수정   ***************************** */\n  /* 수정 시 datepicker */\n  .workPlace-content .react-datepicker {\n    width: -webkit-fill-available;\n    padding: 1rem;\n  }\n\n    /* 버튼 */\n    .workPlace-content .react-datepicker__navigation {\n      height: 40px;\n      top: 1rem;\n    }\n    .workPlace-content .react-datepicker__navigation--previous {\n      left: 1rem;\n    }\n    .workPlace-content .react-datepicker__navigation--next {\n      right: 1rem;\n    }\n\n\n    /* 날짜 나오는 헤더 */\n    .workPlace-content .react-datepicker__header{\n      padding: 0.5rem 0rem 0.5rem 0rem;\n      border-bottom: none;\n    }\n      /* 안에 날짜 */\n      .workPlace-content .react-datepicker__current-month {\n        font-size: large;\n      }\n\n\n    /* 달 전체 안쪽 */\n    .workPlace-content .react-datepicker__month-container {\n      float: none;\n    }\n\n\n    /* 요일 전체 */\n    .workPlace-content .react-datepicker__day-names {\n      font-size: medium;\n      margin-top: 0.5rem;\n    }\n      /* 요일 요소 하나 하나 */\n      .workPlace-content .react-datepicker__day-name {\n        margin: 0.35rem 0.5rem;\n      }\n\n\n    /* 일 */\n    .workPlace-content .react-datepicker__day {\n      margin: 0.35rem 0.5rem;\n      font-size: medium;\n    }\n\n\n\n  /* *************************   등록   ***************************** */\n  /* 등록 시 나오는 datepicker 사이즈 */\n  .workPlace-insertContent .react-datepicker {\n    width: auto;\n    padding: 1rem;\n  }\n\n\n  /* 날짜 선택 시 나타나는 */\n  .custom-input-workPlace {\n    background-color: rgb(0, 0, 0);\n    color: white;\n    border: 1px solid rgb(0, 0, 0);\n    padding: 0.5rem 1rem;\n    /* border-radius: 5px; */\n    cursor: pointer;\n    font-size: large;\n    font-weight: 400;\n    width : max-content;\n    margin: 0.5em 0em;\n    /* box-shadow: 0px 1px cornflowerblue; */\n  }\n\n  .custom-input-workPlace:active {\n    box-shadow: 0 0 0; \n    color: #fff;\n  }\n\n  .workPlace-content .react-datepicker__header {\n    background-color: #fff;\n  }\n\n\n  /* .workPlace-content .react-datepicker__day--today{\n    border-radius: 1rem;\n    background-color: #008fff !important;\n    color: #fff !important;\n  }  */\n\n  /* 하루 */\n  .workPlace-content .react-datepicker__day--selected {\n    border-radius: 1rem;\n    background-color: #008fff !important;\n    color: #fff !important;\n  } \n\n\n  /* range 로 날짜  */\n  .workPlace-content .react-datepicker__day--range-start{\n    border-radius: 1rem 0rem 0rem 1rem;\n    background-color: #008fff !important;\n    color: #fff !important;\n  } \n  .workPlace-content .react-datepicker__day--range-end{\n    border-radius: 0rem 1rem 1rem 0rem;\n    background-color: #008fff !important;\n    color: #fff !important;\n  } \n  .workPlace-content .react-datepicker__day--range-start.react-datepicker__day--range-end{\n    border-radius: 1rem !important;\n    background-color: #008fff !important;\n    color: #fff !important;\n  } \n\n\n  .workPlace-content .react-datepicker__day--in-range{\n    background-color: #b5dfff;\n    color: #000;\n  }\n\n  /* 선택할 때 시작 날짜 */\n  .workPlace-content .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start {\n    border-radius: 1rem 0rem 0rem 1rem;\n    background-color: #008fff;\n    color: #fff;\n  }\n  .workPlace-content .react-datepicker__day--in-selecting-range {\n    background-color: #b5dfff;\n    color: #000;\n  }\n\n\n\n\n/*  */\n  .MuiFormControlLabel-label {\n    font-size: large !important;\n  }\n\n\n/* 선택한 지역 안에 흰 글씨 */\n  .myWorkPlace-text{\n    color: #fff;\n    font-size: small;\n  }\n\n\n\n\n  /* 통계 호버 시 툴팁 */\n .tooltip {\n    display: flex;\n    flex-direction: column;\n    width: max-content;\n    margin: 1rem;\n }\n .tooltip-name {\n    padding-bottom: 0.5em;\n    margin-bottom: 0.5em;\n    border-bottom:1px solid rgb(175, 175, 175);\n }\n .tooltip-name-text {\n    font-size: 1.25rem;\n    font-weight: 700;\n }\n\n .tooltip-text {\n    font-size: 1.25rem;\n    font-weight: 700;\n }\n .tooltip-place {\n    font-size: 1.25rem;\n }\n .tooltip-date {\n    font-size: 1.25rem;\n }\n\n\n\n/* 탭 */\n.workplace-tabs .Mui-selected h4{\n  /* border: 1px solid; */\n  font-weight: bold !important;\n}\n\n.workplace-tabs {\n  background-color: #005fff3d !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
